import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-the-key-technology-challenges-of-emerging-startups-and-how-to-navigate',
  templateUrl: './the-key-technology-challenges-of-emerging-startups-and-how-to-navigate.component.html',
  styleUrls: ['./the-key-technology-challenges-of-emerging-startups-and-how-to-navigate.component.scss']
})
export class TheKeyTechnologyChallengesOfEmergingStartupsAndHowToNavigateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
